import script from "./IressIntegration.vue?vue&type=script&setup=true&lang=js"
export * from "./IressIntegration.vue?vue&type=script&setup=true&lang=js"

import "./IressIntegration.vue?vue&type=style&index=0&id=2f5d2026&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f5d2026"]])

export default __exports__